import React from "react";
import PopoverMenu from "components/popover/menu";
import { connect } from "react-redux";
import classnames from "classnames";
import { getAllLayouts } from "../../state/dashboard-layouts/selectors";
import { getName, getLayoutId } from "../../state/dashboard/selectors";
import "./styles.scss";
import Icon from "../../components/icon";
import Button from "../../components/button";
import { Box, Stack } from "@towersystems/towersystems-design-system";
import { switchLayout } from "../../state/dashboard/actions";
import { AiOutlineMore } from "react-icons/ai";

const SelectReportPopver = ({
  activeDashboardDescription,
  dashboards = [],
  activeDashboardId,
  switchDashboard,
  dashboardfilterFn = (d) => true,
  iconMarkup,
  labelMarkup,
}) => {
  const [isVisible, setIsVisible] = React.useState(false);

  const canActivate = true;

  const handleOnDashboardSelect = (id) => {
    setIsVisible(false);
    switchDashboard(id);
  };

  const activatorMarkup = (
    <div
      className={classnames(
        "select-report-dropdown__activator",
        !canActivate && "not-active"
      )}
      onClick={() => canActivate && setIsVisible(true)}
    >
      {labelMarkup || activeDashboardDescription}
    </div>
  );

  const popoverContent = (
    <div className="select-report-dropdown__content">
      <Stack className="dropdown-link__content">
        {dashboards
          .filter((d) => dashboardfilterFn(d))
          .map((d) => {
            const isActive = d.id == activeDashboardId;
            const classes = classnames("dropdown-link__item", {
              active: isActive,
            });
            return (
              <Box key={d.id} className="dropdown-link__item-wrapper">
                <Button
                  onClick={() => handleOnDashboardSelect(d.id)}
                  disabled={isActive}
                  className={classes}
                >
                  {d.name}
                </Button>
              </Box>
            );
          })}
      </Stack>
    </div>
  );

  return (
    <div>
      <PopoverMenu
        className="select-report-dropdown"
        enterExitTransitionDurationMs={50}
        onOuterAction={() => setIsVisible(false)}
        isOpen={isVisible}
        showArrow={true}
        content={popoverContent}
      >
        {activatorMarkup}
      </PopoverMenu>
    </div>
  );
};

export default connect(
  (state) => {
    return {
      dashboards: getAllLayouts(state),
      activeDashboardId: getLayoutId(state),
      activeDashboardDescription: getName(state),
    };
  },
  {
    switchDashboard: switchLayout,
  }
)(SelectReportPopver);
